import Immutable from "immutable";
import { Client } from "resourceModels";

export default class NuanceLAPlatformRecord extends Immutable.Record({
  name: "nuance_liveagent",
  fullName: "Nuance Live Agent",
  auth: Immutable.Map({
    redirectUri: "",
    clientId: "",
    clientSecret: ""
  }),
  siteId: "",
  enabled: true,

  isVisibleToClient(client: Client): boolean {
    const nuanceLiveAgent = client.features.get("nuanceLiveAgent") || client.features.get("adaGlassNuance");

    return (
      client.hasFullSitePrivileges && nuanceLiveAgent
    );
  }
}) {}
